import React from 'react';
import './FaceRecognition.css';

// Hier wird für alle Gesichter eine Box erstellt
const FaceBox = ({box}) => {
  if(box.length > 0){
    return(
      box.map((data, i)=>{
        return (
          <div key={i} className="bounding-box" style={{top: box[i].topRow,
            right: box[i].rightCol, bottom: box[i].bottomRow, left: box[i].leftCol }}>
          </div>
        );
      })
    );
  } else {
    return null;
  }
}

const FaceRecognition = ({imageUrl, box}) => {
  return(
    <div className='center ma mt3'>
      <div className='absolute mt2'>
        <img id="inputImage" src={imageUrl} alt="" width='500px' height='auto' />
        <FaceBox box={box} />
      </div>
    </div>
  );
}

export default FaceRecognition;
